import styled from 'styled-components';
import { textblocks } from 'seal-ui-components';
import { getBaseTheme } from '@Themes';
import { theme } from '@Themes/themeOverriderFabric';
import Divider from '@Components/UI/Divider';

const { textFieldPlaceholder } = theme.palette;
const { texts, spaces } = getBaseTheme();

export const Container = styled.div({
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '2px',
    borderLeft: props => `4px solid ${props.riskColor}`,
    boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.2)',
    padding: '8px 18px 18px 10px',
    marginBottom: spaces.default.s,
    lineHeight: texts.sizes.m.lineHeight,
    background: 'white'
});

export const PolicyName = styled(textblocks.Heading4)({
    color: props => props.riskColor,
    padding: `${spaces.default.xs} 0`
});

export const TopicText = styled(textblocks.Text)`
    font-size: ${texts.sizes.s.fontSize};
    color: ${textFieldPlaceholder};
    padding: ${spaces.default.xs} 0;
    white-space: pre-wrap;
    word-break: break-all;
`;

export const SubTopicText = styled(textblocks.Text)`
    font-size: ${texts.sizes.xs.fontSize};
    white-space: pre-wrap;
    word-break: break-all;
`;

export const StyledDivider = styled(Divider)({
    margin: `${spaces.default.xs} 0`
});

export const ScoreTitle = styled.div({
    paddingBottom: spaces.default.xs
});

export const Score = styled(textblocks.Heading4)`
    display: inline;
`;
